import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import * as IntegrateBrowserPage from './browser.mdx';
import * as IntegrateNodePage from './node.mdx';
export const _frontmatter = {
  "title": "Integrate",
  "order": 24
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Action = makeShortcode("Action");
const PageLink = makeShortcode("PageLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The same request handlers can be shared between browser and Node environments. Since Service Workers cannot run in Node, the integration process is different depending on the environment.`}</p>
    <Action mdxType="Action">Choose where to run the mocks:</Action>

    <PageLink page={IntegrateBrowserPage} url="/docs/getting-started/integrate/browser" mdxType="PageLink" />
    <PageLink page={IntegrateNodePage} url="/docs/getting-started/integrate/node" mdxType="PageLink" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      